import { Box } from '@chakra-ui/react';
import { SongStatusType } from 'types/song';
import { SongCover } from '../SongCover';

export const SongHeaderBg = ({ status }: { status: SongStatusType }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        w: 'full',
        h: 'full',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          h: 200,
          opacity: 0.36,
          filter: `blur(64px)`,
        }}
      >
        <SongCover
          status={status}
          sx={{
            w: '100%',
            h: 'unset',
            mt: '64px',
            transform: 'translate(0, -50%)',
            aspectRatio: '1/1',
          }}
        />
      </Box>
    </Box>
  );
};
